var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.5875H4C3.45 20.5875 3 20.1375 3 19.5875V15.5875C3 15.3175 3.11001 15.0675 3.29001 14.8775L14.16 4.00749C14.62 3.54749 14.92 3.2475 15.38 3.0975C15.79 2.9675 16.21 2.9675 16.62 3.0975C17.08 3.2475 17.38 3.54749 17.83 3.99749L19.58 5.74749C20.04 6.20749 20.34 6.5075 20.49 6.9675C20.62 7.3675 20.62 7.7975 20.49 8.2075C20.34 8.6575 20.04 8.96749 19.58 9.42749L16.71 12.2975L10.44 18.5675H20.03C20.58 18.5675 21.03 19.0175 21.03 19.5675C21.03 20.1175 20.58 20.5675 20.03 20.5675L20 20.5875ZM5 18.5875H7.59001L14.59 11.5875L12 8.99749L5 15.9975V18.5875ZM13.42 7.58749L16.01 10.1775L18.17 8.0175C18.37 7.8175 18.57 7.6175 18.61 7.5475C18.56 7.5675 18.36 7.36749 18.17 7.17749L16.43 5.4375C16.23 5.2375 16.03 5.03749 15.96 4.99749C15.99 5.03749 15.77 5.2575 15.59 5.4375L13.43 7.5975L13.42 7.58749Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.177c0fa593d516012884f64ccce1465b.svg";
export { ForwardRef as ReactComponent };